import { z } from 'zod';

/** Saved payload content. Absence remains absence; readers resolve it to false. */
export const exportPreferencesSchema = z.strictObject({ includeSourcesPage: z.boolean() });
export const exportPreferenceFields = Object.freeze({
  exportPreferences: exportPreferencesSchema.optional(),
});
